import {
  ControlledTooltip,
  ControlledTooltipBody,
  ControlledTooltipTitle,
} from 'components/DtiRadialMeter/ControlledTooltip'

export const TooltipEstimatedDebtCost = ({ children }) => {
  const componentTitle = <ControlledTooltipTitle>Est. total debt cost</ControlledTooltipTitle>

  const componentBody = (
    <ControlledTooltipBody>
      Your starting debt amount and added interest built up over time
    </ControlledTooltipBody>
  )

  return (
    <ControlledTooltip modalTitle={componentTitle} modalBody={componentBody} iconSize={0}>
      <>{children}</>
    </ControlledTooltip>
  )
}
